
import { mapGetters } from 'vuex'
export default {
    props: {
        plan: {
            type: Object,
            default: null
        },
        collapsibleVisible: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters(['year']),
        pharmacy0 () {
            return this.plan.drug_cost_by_pharmacy_list[0]
        },
    },
}
